import MainNav from "../components/navbar/mainNav";

const Navbar= ()=>{
    return(
        <MainNav/>
    )
}


export default Navbar;